import { render, staticRenderFns } from "./VFatherProAnamCAxCE.vue?vue&type=template&id=7275399b"
import script from "./VFatherProAnamCAxCE.vue?vue&type=script&lang=js"
export * from "./VFatherProAnamCAxCE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports